if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo    = this.productSection.querySelector('.product-info');
      this.productForm    = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          /* ▼-- existing theme logic – don’t change --▼ */
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle(
              'sticky-atc-panel--out',
              entry.boundingClientRect.bottom > 0
            );
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
          /* ▲-- existing theme logic – don’t change --▲ */

          /* ───────────  NEW CODE  ─────────── */
          const header       = document.getElementById('site-header');
          const barIsVisible = !this.classList.contains('sticky-atc-panel--out');
          if (header) header.classList.toggle('hide', barIsVisible);
          /* ─────────────────────────────────── */
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
